import { hash } from 'spark-md5';

// we can take the error message and make a hash that will be displayed in the fallback
export function generateCorrelation(error: Error) {
  if (!error.message) return null;

  const errorHash = hash(error.message).substring(0, 8);
  return errorHash;
}
